import SpaceDashboardOutlinedIcon from "@mui/icons-material/SpaceDashboardOutlined";
import InventoryOutlinedIcon from "@mui/icons-material/InventoryOutlined";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import BusinessOutlinedIcon from "@mui/icons-material/BusinessOutlined";
import GroupOutlinedIcon from "@mui/icons-material/GroupOutlined";
import ScienceOutlinedIcon from "@mui/icons-material/ScienceOutlined";
import AssignmentTurnedInOutlinedIcon from "@mui/icons-material/AssignmentTurnedInOutlined";
import HistoryIcon from "@mui/icons-material/History";
import CodeIcon from "@mui/icons-material/Code";
import GroupIcon from "@mui/icons-material/Group";
import AnalyticsOutlinedIcon from "@mui/icons-material/AnalyticsOutlined";
import SettingsApplicationsOutlinedIcon from "@mui/icons-material/SettingsApplicationsOutlined";

export const useNav = () => {
  const listItems = [
    {
      label: "Dashboard",
      icon: <SpaceDashboardOutlinedIcon />,
      path: "/",
    },
    {
      label: "Studies",
      icon: <ScienceOutlinedIcon />,
      path: "/studies",
      permission: "VIEW_ALL_STUDIES",
    },
    {
      label: "Accessions",
      icon: <AssignmentTurnedInOutlinedIcon />,
      path: "/accessions",
    },
    {
      label: "Enrollment",
      icon: <GroupIcon />,
      path: "/enrollment",
    },
    {
      label: "Inventory",
      icon: <InventoryOutlinedIcon />,
      path: "/inventory",
    },
    {
      label: "Reports",
      icon: <ArticleOutlinedIcon />,
      path: "/reports",
    },
    {
      label: "Sites, Labs & Vendors",
      icon: <BusinessOutlinedIcon />,
      path: "/sites-lab",
    },
    {
      label: "Exploratory Analysis",
      icon: <AnalyticsOutlinedIcon />,
      path: "/exploratory-analysis",
    },
    {
      label: "Users",
      icon: <GroupOutlinedIcon />,
      path: "/users",
      permission: "VIEW_ALL_USERS",
    },
    {
      label: "Codelists",
      icon: <CodeIcon />,
      path: "/codelists",
      permission: "VIEW_ALL_CODELISTS",
    },
    {
      label: "Audit Trail",
      icon: <HistoryIcon />,
      path: "/audit",
      permission: "VIEW_AUDIT_TRAIL",
    },
    {
      label: "Configuration",
      icon: <SettingsApplicationsOutlinedIcon />,
      path: "/configuration",
      permission: "MANAGE_CONFIGURATIONS",
    },
  ];
  return {
    listItems,
  };
};
